import { Box, Tooltip, Typography } from '@mui/material';
import { InfoOutlined } from '@mui/icons-material';

const SOURCE_TZ_LABEL = 'UTC+2';

export const StartTimeHeader = ({ headerName }: { headerName?: string }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
    <Typography sx={{ fontWeight: 500, fontSize: 14 }}>{headerName}</Typography>
    <Typography sx={{ fontSize: 14, color: 'text.disabled' }}>
      {SOURCE_TZ_LABEL}
    </Typography>
  </Box>
);

export const BudgetsHeader = ({ headerName, tooltip = '' }: { headerName?: string, tooltip?: string }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    <Typography sx={{ fontWeight: 500, fontSize: 14 }}>{headerName}</Typography>
    <Tooltip title={tooltip}>
      <InfoOutlined sx={{ fontSize: 18 }} />
    </Tooltip>
  </Box>
);
